// tslint:disable
/**
 * CONEXSYS ProductCategory Portal API
 * The API for the CONEXSYS ProductCategory Portal
 *
 * The version of the OpenAPI document: 2.0.0
 * ProductCategory: support@conexsys.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { virtualConfig as config } from '../../../config/virtual';
import { apiRequest, setEntitiesApiOperationState } from '../../../app/api';
import { ProductCategoryHelper } from '../classes';
import moment from 'moment';
import _ from 'lodash';

import { ProductCategoryEntities } from '../collections';
import { State_ApiOperationContextTypes } from '../../../storage';
import { UseCtx } from '../../../config/hooks';

export enum ProductCategoryApiOperation {
	readProductCategories = 'readProductCategories'
}

export interface ReadProductCategoriesRequest {
	eventId: string;
	modifiedFrom?: string;
	ids?: string[];
	queryLimit?: number;
	queryBookmark?: string;
}

/**
 * Read productCategories
 */
export async function readProductCategories(
	ctx: UseCtx<any>,
	requestParameters: ReadProductCategoriesRequest
): Promise<ProductCategoryEntities> {
	const operationId = ProductCategoryApiOperation.readProductCategories;

	// get the attempt date now BEFORE the request is made so there is no GAP in time if the request takes awhile or fails
	const attemptDate: string = moment().toISOString();

	// make the api request
	const response = await apiRequest<
		ProductCategoryEntities,
		ReadProductCategoriesRequest
	>(ctx, config.apiId, operationId, requestParameters);

	let entities: ProductCategoryEntities | undefined = response.response.data;
	if (!entities) entities = [];

	if (entities.length > 0) {
		// set each entity.__state.eventId to the eventId from the params
		entities.forEach((entity, i, a) => {
			a[i].__state = _.merge(entity.__state || {}, {
				eventId: requestParameters.eventId
			});
		});

		// patch entities with an api success data for the operation
		setEntitiesApiOperationState<
			ProductCategoryEntities,
			ProductCategoryHelper
		>(
			ctx.virtual.productCategory,
			entities,
			operationId,
			State_ApiOperationContextTypes.Success,
			attemptDate
		);
		// upsert the entities to the store
		ctx.virtual.productCategory.upsert(entities);
	}

	// return the entities to the caller for direct reference
	return entities;
}
